/** 计算怪物击杀或抵达基地时发放的金币，先应用难度倍率并四舍五入，再向下减半。 */
export function calculateMonsterGoldReward(baseReward: number, multiplier: number): number {
  return Math.floor(Math.round(baseReward * multiplier) / 2);
}
